import { FC, useState } from 'react'
import { useForm } from 'react-hook-form'

import './style.scss'
import { utils } from '../../utils'
import { IAuthRegisterPassportForm } from '../../models'
import { Button, Text } from '../UI'
import passportDefaultImg from '../../assets/img/passport.svg'
import photoPassportDefaulImg from '../../assets/img/photo-passport.svg'
import Avatar from 'react-avatar'

type registerFormPassportProps = {
  onSubmit(data: any): void
}

const BoxFile:FC<{ className?: string }> = ({ children, className = 'mt-5'}) => {
  return (
    <div className={`register-form-passport lg:h-75 pt-20 lg:pb-70 ${className}`}>{children}</div>
  )
}

const Label:FC<{ className?: string }> = ({ children, className = 'mt-5'}) => {
  return (
    <Text component="label" size="14" weight="semibold" inline className={`d-block text-center lg:text-left lg:pl-50 ${className}`}>{children} <span className="text-primary">*</span></Text>
  )
}

const isFirefox: boolean = utils.isBrowserByName('FIREFOX')

const RegisterFormPassport:FC<registerFormPassportProps> = ({ onSubmit })  => {
  const { register, handleSubmit, formState: { errors }, setValue, setError, clearErrors } = useForm<IAuthRegisterPassportForm>()
  const [passportImg, setPassportImg] = useState<string>('')
  const [photoPassportImg, setPhotoPassportImg] = useState<string>('')

  const onFileChange = (event: any) => {
    const { target: { name, files } } = event

    if(files && files[0]) {
      const fieldName = name
      const fileType = files[0].type
      const fileSize = files[0].size

      if(fileType && (fileType.indexOf('png') === -1 && fileType.indexOf('jpeg') === -1)) {
        setError(fieldName, {
          type: 'format',
          message: 'Selecciona formato png ó jpg'
        })
        setValue(fieldName, '')
        return ;
      } else if(fileSize && (fileSize / 1024 > 500)) {
        setError(fieldName, {
          type: 'size',
          message: 'Selecciona tamaño máximo 500KB'
        })
        setValue(fieldName, '')
        return ;
      }

      const fileImage = URL.createObjectURL(files[0])

      if(fieldName === 'passport') setPassportImg(fileImage)
      else if(fieldName === 'photoPassport') setPhotoPassportImg(fileImage)
      if(!isFirefox) setValue(fieldName, files)
      clearErrors(fieldName)
    }
  }

  const onBtnFileClick = (name: string) => {
    const inputFile = document.getElementById(name)

    if(inputFile) inputFile.click()
  }

  return (
    <>
      <Text size="14" lineHeight="6" className="lg:fz-16">Para validar tu identidad necesitamos 2 fotografías de tu pasaporte</Text>

      <form noValidate autoComplete="off" onSubmit={handleSubmit(onSubmit)} className="mt-40 lg:mt-30">
        <div className="row">
          <div className="col-12 lg:col-6">
            <Label>Fotografía de tu pasaporte</Label>

            <BoxFile>
              <Avatar
                src={passportImg ? passportImg : passportDefaultImg}
                size="209"
                className="register-form-passport-avatar_img"
              />

              <div className="lg:col-10 mx-auto px-0 lg:px-15 mt-20">
                <div className="register-passport-file-btn">
                  <Button type="button" size="md" borderRadius="4px" fullWidth onClick={() => onBtnFileClick('passport')}>CARGAR FOTOGRAFÍA DEL DOCUMENTO</Button>
                  <input
                    {...register('passport', { required: 'Selecciona Fotografía de tu pasaporte' })}
                    type="file"
                    id="passport"
                    name="passport"
                    accept="image/x-png,image/jpeg"
                    onChange={onFileChange}
                  />
                </div>
                {errors.passport && <Text component="label" size="12" color="danger" className="mt-5">{errors.passport?.message}</Text>}
              </div>
            </BoxFile>
          </div>

          <div className="col-12 lg:col-6 mt-40 lg:mt-0">
            <Label>Fotografía de ti con tu pasaporte</Label>

            <BoxFile>
              <Avatar
                src={photoPassportImg ? photoPassportImg : photoPassportDefaulImg}
                size="209"
                className="register-form-passport-avatar_img"
              />

              <div className="col-12 lg:col-10 mx-auto px-0 lg:px-15 mt-20">
                <div className="register-passport-file-btn">
                  <Button type="button" size="md" borderRadius="4px" fullWidth onClick={() => onBtnFileClick('photoPassport')}>CARGAR FOTOGRAFÍA DEL DOCUMENTO</Button>
                  <input
                    {...register('photoPassport', { required: 'Selecciona Fotografía de ti con tu pasaporte' })}
                    type="file"
                    id="photoPassport"
                    name="photoPassport"
                    accept="image/x-png,image/jpeg"
                    onChange={onFileChange}
                  />
                </div>
                {errors.photoPassport && <Text component="label" size="12" color="danger" className="mt-5">{errors.photoPassport?.message}</Text>}
              </div>
            </BoxFile>
          </div>
        </div>

        <div className="register-btn-wrapper mt-30">
          <Button type="submit" fullWidth>CONTINUAR</Button>
        </div>
      </form>
    </>
  )
}

export { RegisterFormPassport }